'use client'

import { Menu, MenuItem } from '@/graphql/generated/graphql'
import Link from 'next/link'
import { useState } from 'react'

type Props = {
  menu: Menu
}
export default function MobileMenu({ menu }: Readonly<Props>) {
  const [showMenu, setShowMenu] = useState(false)
  const [activeSubMenu, setActiveSubMenu] = useState<string>()

  return (
    <>
      <button
        onClick={() => setShowMenu(!showMenu)}
        data-collapse-toggle="navbar-dropdown"
        type="button"
        className="inline-flex h-10 w-10 items-center justify-center rounded-lg p-2 text-sm text-zinc-600 hover:bg-zinc-800 hover:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-gray-200 lg:hidden"
        aria-controls="navbar-dropdown"
        aria-expanded="false"
      >
        <span className="sr-only">Open main menu</span>
        <svg className="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M1 1h15M1 7h15M1 13h15"
          />
        </svg>
      </button>
      <div
        className={`mt-4 w-full overflow-hidden transition-all duration-300 lg:hidden ${showMenu ? 'max-h-[800px] opacity-100' : 'max-h-0 opacity-0'}`}
      >
        <div className="w-full p-2 text-sm font-normal text-zinc-400 md:rounded-lg md:border md:border-zinc-700 md:bg-zinc-800">
          {menu.menuItems?.nodes
            .filter((menuItem: MenuItem) => menuItem?.parentId === null)
            .map((item) => (
              <div key={item.id}>
                <div onClick={() => setActiveSubMenu(item.id)} key={item.id} className="text-lg font-bold text-white">
                  {item.label}
                </div>
                {menu?.menuItems?.nodes
                  .filter((subMenu: MenuItem) => subMenu.parentId === item.id)
                  .map((i) => (
                    <div
                      key={i.id}
                      className={`${activeSubMenu === i.parentId ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'} w-full overflow-hidden transition-all duration-300`}
                    >
                      <Link href={i.url || '#'} className="py-4 ps-4 text-lg focus:text-white">
                        {i.label}
                      </Link>
                    </div>
                  ))}
              </div>
            ))}
        </div>
      </div>
    </>
  )
}
